import jQuery from "jquery";
import 'devbridge-autocomplete';
import { initPhoneInputs } from './phone-input';
const infoImage = '/app/themes/decolegno-new/assets/images/info.svg';
const infoImageHover = '/app/themes/decolegno-new/assets/images/info-hover.svg';

document.addEventListener('DOMContentLoaded', () => {
    void initPhoneInputs();

    const initialAccountData = {
        coc_number: document.querySelector('[name="coc_number"]')?.value || '',
        billing_company: document.querySelector('#billing_company')?.value || '',
        billing_address_1: document.querySelector('#billing_address_1')?.value || '',
        billing_address_1_street: document.querySelector('#billing_address_1_street')?.value || '',
        billing_address_1_housenr: document.querySelector('#billing_address_1_housenr')?.value || '',
        billing_housenr: document.querySelector('#billing_housenr')?.value || '',
        billing_postcode: document.querySelector('#billing_postcode')?.value || '',
        billing_postcode_clone: document.querySelector('#billing_postcode_clone')?.value || '',
        billing_city: document.querySelector('#billing_city')?.value || '',
        website: document.querySelector('#website')?.value || ''
    };


    function removeReadonlyWhenNoValue() {
        const isLoggedIn = document.querySelector('.logged-in');
        if (!isLoggedIn) return;

        const fields = document.querySelectorAll('.woocommerce-billing-fields__field-wrapper .form-row input[readonly]');

        fields.forEach(field => {
            if (field.value === '') {
                field.removeAttribute('readonly');
                const formRow = field.closest('.form-row');
                if (formRow) {
                    const abbr = formRow.querySelector('abbr');
                    if (abbr) {
                        abbr.style.display = 'contents';
                    }
                }
            }
        });

        // Special for the coc_number_field
        const cocField = document.querySelector('#coc_number_field input[readonly]');

        if (cocField && cocField.value === '') {
            cocField.removeAttribute('readonly');
            const formRow = cocField.closest('.form-row');
            if (formRow) {
                const abbr = formRow.querySelector('abbr');
                if (abbr) {
                    abbr.style.display = 'contents';
                }
            }
        }

    }

    removeReadonlyWhenNoValue();

    function showNotificationWhenCheckboxIsClicked() {
        const isLoggedIn = document.querySelector('.logged-in');
        if (!isLoggedIn) return;

        const checkbox = document.querySelector('#ship-to-same-address-checkbox');
        const label = document.querySelector('#ship-to-same-address label');
        const span = label?.querySelector('span');

        if (!span) {
            return;
        }

        const wrapperDiv = document.createElement('div');
        wrapperDiv.classList.add('wrapper-div');

        span.parentNode.insertBefore(wrapperDiv, span);
        wrapperDiv.appendChild(span);

        checkbox.addEventListener('change', () => {
            const existingParagraph = document.getElementById('ship-to-same-address__notification');
            if (existingParagraph) {
                existingParagraph.remove();
            }

            if (checkbox.checked) {
                const newParagraph = document.createElement('p');
                newParagraph.textContent = 'Controleer je factuurgegevens voordat je een bestelling plaatst.';
                newParagraph.id = 'ship-to-same-address__notification';
                wrapperDiv.appendChild(newParagraph);
            }
        });
    }

    showNotificationWhenCheckboxIsClicked();

    let openModal = null;
    let openImg = null;

    function onHoverImg() {
        document.querySelectorAll('.form-row').forEach(row => {
            const hotspot = row.querySelector('.billing-tooltip');
            const img     = row.querySelector('.billing-tooltip img');
            const input   = row.querySelector('.woocommerce-input-wrapper');
            const modal   = row.querySelector('.billing-tooltip__modal');

            if (!hotspot || !img || !input || !modal) return;

            hotspot.addEventListener('mouseover', () => {
                if (openModal && openModal !== modal) {
                    openModal.style.display = 'none';
                    if (openImg) openImg.src = infoImage;
                    openModal = null;
                    openImg   = null;
                }

                img.src = infoImageHover;
            });

            hotspot.addEventListener('mouseout', () => {
                if (openModal !== modal) img.src = infoImage;
            });

            input.addEventListener('mousedown', e => {
                e.stopPropagation();

                if (openModal && openModal !== modal) {
                    openModal.style.display = 'none';
                    if (openImg) openImg.src = infoImage;
                }

                modal.style.display = 'block';
                img.src   = infoImageHover;
                openModal = modal;
                openImg   = img;
            });
        });

        document.addEventListener('click', e => {
            if (openModal && !openModal.contains(e.target)) {
                openModal.style.display = 'none';
                if (openImg) openImg.src = infoImage;
                openModal = null;
                openImg   = null;
            }
        });
    }



    function addTooltip(fieldId = null) {
        const tooltipText = document.getElementById('tooltip_checkout_page')?.value;
        const isLoggedIn = document.querySelector('.logged-in');
        if (!isLoggedIn || !tooltipText) return;

        const fields = fieldId
            ? [document.querySelector(`#${fieldId}`)]
            : document.querySelectorAll('.woocommerce-billing-fields__field-wrapper .form-row');

        fields.forEach((field) => {
            if (!field) return;

            const label = field.querySelector('label');
            const input = field.querySelector('input, select, textarea'); // Check for input elements

            if (!label || !input || (input.tagName === 'SELECT' ? false : !input.readOnly)) {
                return;
            }

            if (field.querySelector('.billing-tooltip')) {
                return;
            }

            // Create tooltip elements
            const wrapperDiv = document.createElement('div');
            const span = document.createElement('span');
            const img = document.createElement('img');
            const modal = document.createElement('div');

            wrapperDiv.classList.add('label-wrapper');
            span.classList.add('billing-tooltip');
            modal.classList.add('billing-tooltip__modal');
            modal.innerHTML = tooltipText;
            img.src = infoImage;
            img.alt = 'Info';

            // Build the tooltip structure
            span.appendChild(img);
            span.appendChild(modal);

            // Wrap the label and add tooltip
            label.parentNode.insertBefore(wrapperDiv, label);
            wrapperDiv.appendChild(label);
            wrapperDiv.appendChild(span);
        });
    }

    addTooltip();
    addTooltip('coc_number_field');
    addTooltip('billing_country_field');
    onHoverImg();

    function getCheckoutConfig() {
        return window.localCheckout || null;
    }

    function setFieldValue(form, selector, value) {
        const field = form.querySelector(selector);
        if (!field) return;

        field.value = value || '';

        field.dispatchEvent(new Event('input', { bubbles: true }));
        field.dispatchEvent(new Event('change', { bubbles: true }));

        const formRow = field.closest('.form-row');
        if (!formRow) return;

        if (field.value === '') {
            formRow.classList.remove('woocommerce-validated');
            return;
        }

        formRow.classList.remove('woocommerce-invalid', 'woocommerce-invalid-required-field');
        formRow.classList.add('woocommerce-validated');
    }

    function updateFormFields(input, item) {
        if (!item) return;
        document.body.classList.add('manual-address');
        const form = input.closest('form');
        form.querySelector('a[href="#addr-manual"]')?.click();
        setFieldValue(form, '[name="coc_number"]', item.cocNumber);

        if (item.address) {
            setFieldValue(form, '#billing_address_1', [item.address.street, item.address.houseNumber, item.address.postalCode].filter(Boolean).join(' '));
            setFieldValue(form, '#billing_address_1_street', item.address.street);
            setFieldValue(form, '#billing_address_1_housenr', item.address.houseNumber);
            setFieldValue(form, '#billing_housenr', item.address.houseNumber);
            setFieldValue(form, '#billing_postcode', item.address.postalCode);
            setFieldValue(form, '#billing_postcode_clone', item.address.postalCode);
            setFieldValue(form, '#billing_city', item.address.city);
        }
        setFieldValue(form, '#website', item.website);
    }

    function attachAutocompleteBE(input, config) {
        const company = jQuery(input);
        company.devbridgeAutocomplete({
            serviceUrl: `${config.ajax_url}?action=${config.action}&countryCode=${config.country}&key=${config.nonce}`,
            dataType: 'json',
            paramName: 'q',
            ajaxSettings: {
                beforeSend: function () {
                    company.closest('.form-row').addClass('is-loading');
                    company.closest('.woocommerce-input-wrapper').addClass('coc-loader');
                },
                success: function () {
                    company.closest('.form-row').removeClass('is-loading');
                    company.closest('.woocommerce-input-wrapper').removeClass('coc-loader');
                },
                error: function () {
                    company.closest('.form-row').removeClass('is-loading');
                    company.closest('.woocommerce-input-wrapper').removeClass('coc-loader');
                }
            },
            transformResult: function (response) {
                if (!Array.isArray(response)) {
                    return { suggestions: [] };
                }
                return {
                    suggestions: response.map(function (item) {
                        return {
                            value: String(item.name),
                            data: String(item.companyNumber)
                        };
                    })
                };
            },
            minChars: 2,
            triggerSelectOnValidInput: false,
            autoSelectFirst: true,
            deferRequestBy: 500,
            onSelect: function (suggestion) {
                company.closest('.form-row').addClass('is-loading');
                company.closest('.woocommerce-input-wrapper').addClass('coc-loader');
                jQuery.getJSON(
                    config.ajax_url +
                    '?companyId=' + suggestion.data +
                    '&action=' + config.complete_action +
                    '&key=' + config.complete_nonce,
                    function (data) {
                        company.closest('.form-row').removeClass('is-loading');
                        company.closest('.woocommerce-input-wrapper').removeClass('coc-loader');
                        updateFormFields(company[0], data);
                    }
                );
            },
            onHide: () => {}
        });
    }

    document.querySelectorAll('.billing-company-ac input:not([readonly])').forEach(input => {
        const config = getCheckoutConfig();
        if (config) attachAutocompleteBE(input, config);
    });

    function setupExclusiveCheckboxes() {
        const sameAddressCheckbox = document.querySelector('#ship-to-same-address-checkbox');
        const differentAddressCheckbox = document.querySelector('#ship-to-different-address-checkbox');
        const differentAddressForm = document.querySelector('.shipping_address');

        if (!sameAddressCheckbox || !differentAddressCheckbox) {
            return;
        }

        sameAddressCheckbox.addEventListener('change', function() {
            if (this.checked) {
                differentAddressCheckbox.checked = false;
                differentAddressCheckbox.dispatchEvent(new Event('change'));
                differentAddressForm.style.display = 'none';
            }
        });

        differentAddressCheckbox.addEventListener('change', function() {
            if (this.checked) {
                sameAddressCheckbox.checked = false;
                sameAddressCheckbox.dispatchEvent(new Event('change'));

                differentAddressForm.style.display = 'block';
                return;
            }

            differentAddressForm.style.display = 'none';
        });
    }

    setupExclusiveCheckboxes();

    /** WooCommerce marks shipping_country validated on programmatic change; keep neutral styling until user interacts. */
    let shippingCountryTouchedByUser = false;

    function setupShippingCountryTouchState() {
        const touchClass = 'is-shipping-country-touched';

        function applyShippingCountryTouched() {
            shippingCountryTouchedByUser = true;
            document.getElementById('shipping_country_field')?.classList.add(touchClass);
        }

        function resetShippingCountryTouchState() {
            shippingCountryTouchedByUser = false;
            document.getElementById('shipping_country_field')?.classList.remove(touchClass);
        }

        /** Select2 emits jQuery-only events on the underlying select. */
        function bindSelect2CloseOnShippingCountry() {
            const select = document.getElementById('shipping_country');
            if (!select || select.dataset.decoShippingCountrySelect2Touch === '1') {
                return;
            }
            select.dataset.decoShippingCountrySelect2Touch = '1';
            jQuery(select).on('select2:close', applyShippingCountryTouched);
        }

        document.body.addEventListener('focusout', (event) => {
            if (event.target?.id === 'shipping_country') {
                applyShippingCountryTouched();
            }
        });

        document.body.addEventListener('change', (event) => {
            const target = event.target;
            if (target?.id === 'ship-to-different-address-checkbox' && !target.checked) {
                resetShippingCountryTouchState();
            }
        });

        function onUpdatedCheckout() {
            const differentChecked = document.querySelector('#ship-to-different-address-checkbox')?.checked;
            const field = document.getElementById('shipping_country_field');
            if (shippingCountryTouchedByUser && differentChecked && field) {
                field.classList.add(touchClass);
            } else if (!differentChecked) {
                resetShippingCountryTouchState();
            }
            bindSelect2CloseOnShippingCountry();
        }

        jQuery(document.body).on('updated_checkout', onUpdatedCheckout);

        bindSelect2CloseOnShippingCountry();
        window.addEventListener('load', bindSelect2CloseOnShippingCountry);
    }

    setupShippingCountryTouchState();

    function handleEntityTypeChange() {
        const entityTypeSelects = document.querySelectorAll('[name="entity_type"]');
        const form = document.querySelector('form.checkout');

        if (!form) return;

        entityTypeSelects.forEach(select => {
            select.addEventListener('change', () => {
                setFieldValue(form, '[name="coc_number"]', initialAccountData.coc_number);
                setFieldValue(form, '#billing_company', initialAccountData.billing_company);
                setFieldValue(form, '#billing_address_1', initialAccountData.billing_address_1);
                setFieldValue(form, '#billing_address_1_street', initialAccountData.billing_address_1_street);
                setFieldValue(form, '#billing_address_1_housenr', initialAccountData.billing_address_1_housenr);
                setFieldValue(form, '#billing_housenr', initialAccountData.billing_housenr);
                setFieldValue(form, '#billing_postcode', initialAccountData.billing_postcode);
                setFieldValue(form, '#billing_postcode_clone', initialAccountData.billing_postcode_clone);
                setFieldValue(form, '#billing_city', initialAccountData.billing_city);
                setFieldValue(form, '#website', initialAccountData.website);

                removeReadonlyWhenNoValue();
            });
        });
    }

    handleEntityTypeChange();
});